
function WasserTirolCockpit() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Cockpit.Home visual. <br/>
    /// It does the left-menu item handling, the notification handling and some browser-width fixing. 
    /// <br/>
    /// Author: ARF<br />
    /// Date: 9.10.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 18.1.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Cockpit.Home.vb
    this.day = "";
}

WasserTirolCockpit.prototype = new Cockpit();

WasserTirolCockpit.prototype.init = function () {

    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
       
        me.showInfo("", "", false);

       // me.visual.find('.group .item').tipTip({ defaultPosition: 'bottom' });

        if (me.mobile === false) {
            me.visual.find("#divContentSub1").width(parseInt(me.visual.find("#divContentSub1").width(), 10) - parseInt(me.visual.find("#divCockpitMenu").width(), 10) - 20);
        }
        //adds the clickhandler for the menu items
        me.visual.find(".group .item").off("click").on("click", function () {
            me.loadContent($(this), false);
        });


        //loads the first menu item at the start
        me.loadContent($(me.visual.find(".group .item")[0]), true);

        //clickhandler for the currency icon
        me.visual.find("#divCurrency").off("click").on("click", function () {
            me.toggleCurrency($(this));
        });

        //loads the notifications
        if (me.HasAlarm) { me.loadAlarmNotes();}
        if (me.HasNews) { me.loadNewsNotes();}
        if (me.HasActivities) { me.loadActivityNotes();}

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



WasserTirolCockpit.prototype.loadContent = function (obj, bInit) {
    /// <summary>
    /// This function loads the content for the given menu object/item. 
    /// On init it loads mandatory notes - if any exist - as well.
    /// </summary>
    var me = this;
    var visualname;
    var bsagid;
    var parameter = "";
    var signalparameter = "";
    var found = false;
    var height = 0;
    var bUsePrices;
    try {
        if (me.error) { return false; }
        if (obj.length === 0) { return false}

        //set the current menu item 
        me.currentMenu = obj;

        me.visual.find(".group .item").removeClass("selected");
        obj.addClass("selected");

        me.vcVisual.setShowSettings(false);
        me.vcVisual.setShowFullscreen(false);

        visualname = obj.attr("data-visual");
        bsagid = parseInt(obj.attr("data-bsagid"),10);

        bUsePrices = me.visual.find("#divCurrency").hasClass("ui-state-active");
        
        switch (visualname) {
        case "VISUAL_COCKPIT_SELECTION": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices }); found = true; break;
            case "CONTAINER_DAILY_SUMSIGNALS": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices, 'Interval': 1, 'ShowSummaries': false }); found = true; break;
            case "CONTAINER_WEEKLY_SUMSIGNALS": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices, 'Interval': 1, 'ShowSummaries': false }); found = true; break;
            case "CONTAINER_MONTHLY_SUMSIGNALS": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices, 'Interval': 3, 'DataType': 5, 'ShowSummaries': false }); found = true; break;
            case "CONTAINER_YEARLY_SUMSIGNALS": signalparameter = JSON.stringify({ 'UsePrices': bUsePrices, 'Interval': 5, 'DataType': 5, 'ShowSummaries': false }); found = true; break;
            case "CONTAINER_WASSERTIROL_ANALOG_SIGNALS": signalparameter = JSON.stringify({  'UsePrices': bUsePrices }); found = true; break;
            case "CONTAINER_ANALOG_SIGNALGROUP": signalparameter = JSON.stringify({ 'bsagid': bsagid, 'UsePrices': bUsePrices }); found = true; break;
            case "VISUAL_MENU_TOGGLE_ALARM": height = 1000; found = true; break; //alarm history
            case "VISUAL_HR_FULL":  height = 850; found = true;  break; //high resolution
            case "VISUAL_MENU_TOGGLE_ACTIVITY": height=10500; found = true; me.loadActivityNotes(); break; //activities
            case "WIDGET_GALLERY_MENU": found = true; break; //docs
            case "WIDGET_PROJECT_CONTACTS": found = true; break; //project contacts
            case "VISUAL_MENU_TOGGLE_EVENT": found = true; parameter = ''; break; //interventions
            case "VISUAL_MASTER_MENU": found = true; parameter = ''; break;
            case "VISUAL_MASTER_LOGGERLIST": found = true;parameter = ''; break;
            case "WIDGET_MONITORINGICONS": found = true; parameter = ''; break; //interventions
            case "VISUAL_NOTIFICATION_LIST": found = true; parameter = ''; break; //notifiactions/news
            case "VISUAL_INPUT_READING": found = true; parameter = ''; break; //notifiactions/news
            case "VISUAL_DATACENTER_SINGLESIGNAL": found = true; parameter = ""; break; //notifiactions/news

            case "VISUAL_WASSERTIROL_REPORTS": me.visual.find("#divContentSub1").html('coming soon ...'); break; //notifiactions/news

        }

        if (found) {
            me.visual.find("#divContentSub1").html(me.vcC.getLoadingIcon());
            //jump to the top of the page
            window.scrollTo(0, 0);
           
            me.vcVisual.addVisualByName("divContent", visualname, 'Sub1', me.day, height, parseInt($("#divContentSub1").width(), 10), parameter, signalparameter, me.deviceType, function () {
                //load the mandatory notes the first time we load the content
                if (bInit) {  me.loadMandatoryNotes(); }
            });
        }
        
      

        return true;
    } catch (ex) { me.writeError('loadContent', ex); return false}
}

